import { createStyles, Group, Stack } from '@mantine/core';
import { Button, Text, Title } from '@repo/foundations';
import type { IIntegration } from '../../../../../api';
import { SelectIntegrationGroupsController } from '../../../../../features/SelectIntegrationGroups';
import type { IntegrationSpec } from '../../../../../interfaces/IntegrationSpec.ts';

const useStyles = createStyles(
	(theme, { maxHeight }: { maxHeight: string }) => ({
		treeWrapper: {
			position: 'relative',
			overflow: 'visible',
			maxHeight,
		},
	})
);

interface SelectStepProps {
	integration: IIntegration;
	integrationSpec: IntegrationSpec;
	nextStep: () => void;
	hideTitle?: boolean;
	maxHeight?: string;
	hideSubmit?: boolean;
	height?: string;
}

export function SelectStep({
	integration,
	integrationSpec,
	nextStep,
	hideTitle = false,
	maxHeight = '50vh',
	hideSubmit = false,
	height,
}: SelectStepProps) {
	const { classes } = useStyles({ maxHeight });

	return (
		<Stack spacing="xl">
			{!hideTitle && (
				<Stack spacing="xs">
					<Title size="xl">Import</Title>
					{integrationSpec.type === 'builtin' && (
						<Text size="sm" color="text/secondary/default">
							Select the{' '}
							{integrationSpec.value.supportsSchemaConfiguration
								? 'schemas'
								: 'folders'}{' '}
							you&apos;d like to include in the sync
						</Text>
					)}
				</Stack>
			)}
			<Stack spacing="sm" h="100%" className={classes.treeWrapper}>
				<SelectIntegrationGroupsController
					integration={integration}
					spec={integrationSpec}
					refreshOnLoad
					height={height}
				/>
			</Stack>
			{!hideSubmit && (
				<Group position="right">
					<Button variant="primary" size="md" onClick={nextStep}>
						Continue to sync
					</Button>
				</Group>
			)}
		</Stack>
	);
}
